import lodash from "lodash";
export const OPERATION_COLUMNS = {
	name: "name",
	description: "long_text_mkq92502",
	timelineOriginal: "timerange_mkvd4xre",
	timeline: "lookup_mkwqqpnr",
	status: "color_mkq9abwz",
	creator: "board_relation_mks0mw13",
	assignees: "board_relation_mkqzks56",
	deadline: "date_mkq9439w",
	services: "board_relation_mks04gw0",
	servicesIds: "text_serviceid",
	marketingPlans: "board_relation_mkqzz2gj",
	marketingPlansIds: "text_marketingplanid",
	campaigns: "board_relation_mkr67ghm",
	campaignsIds: "text_campaignsid",
	projects: "board_relation_mkqznsmd",
	entities: "dropdown_mksmp5j3",
	creationDate: "date_mkq9a3x7",
	briefId: "text_mkq9dag2",
	files: "file_mkq9majy",
	thumbnail: "file_thumbnail",
	products: "board_relation_mkv7bz2x",
	boxFolderId: "numeric_mkx7e2w",
	tasksStatus: "lookup_mkv7nmap",
	quotes: "board_relation_mkqbm5mh",
	productsStatus: "lookup_mkwp1trs",
	productsCount: "lookup_mkx525d5",
	proof: "text_mkx5cy77",
	proofStatus: "color_mkx5de73",
	expenses: "lookup_mkx5gdf7",
	supportDuration: "formula_mkx5jhhx",
	completionDuration: "formula_mkx5349p",
	versionCount: "lookup_mkx5qsa7",
} as const;

export const OPERATION_ITEMS_COLUMNS = {
	name: "name",
	job: "dropdown_mkqzfcpp",
	channel: "color_mktcv2fk",
	workflowSteps: "dropdown_mkwks2vt",
	prices: "numeric_mkwqsryy",
	timeline: "delivery_date_sup",
	urgent: "sub_urgent_brief",
	status: "sub_status_brief",
} as const;

export enum OPERATION_STATUS {
	none = "",
	Draft = "#757575",
	ToBeCategorized = "#9d50dd",
	ToBeStarted = "#216edf",
	ToBeChecked = "#ff007f",
	Running = "#fdab3d",
	Complete = "#00c875",
	Blocked = "#df2f4a",
	Paused = "#ffcb00",
	Canceled = "#333333",
	QuoteNeeded = "#037f4c",
}

export enum OPERATION_ITEM_STATUS {
	none = "",
	Deleted = "Deleted",
	New = "NEw",
}

export const DEFAULT_OPERATION_STATUS = lodash.pullAll(
	Object.values(OPERATION_STATUS),
	["", OPERATION_STATUS.Complete, OPERATION_STATUS.Canceled],
);
